import "./NavigationServices.module.css";
import MainNavigation from "@/reusable_sections/Header";
import PrecisionMethodologies from "./sections/PrecisionMethodologies";
import TheWeightLossProcess from "./sections/TheWeightLossProcess";
import SecureYourVisit from "./sections/SecureYourVisit";
import Footer from "@/reusable_sections/Footer";
export default function NavigationServicesPage() {
  return <div>
      <MainNavigation />
      <PrecisionMethodologies />
      <TheWeightLossProcess />
      <SecureYourVisit />
      <Footer />
    </div>;
}